import Avatar from '@alltrails/shared/denali/components/Avatar';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const StatusUpdateItem = createReactClass({
  render() {
    const statusUpdate = this.props.status_update;
    if (!statusUpdate || !statusUpdate.display) {
      return null;
    }

    return (
      <div key={statusUpdate.id} className="comment">
        <div className="user-avatar floatleft">
          <a href={statusUpdate.image_path}>
            <Avatar
              userName={this.props.user?.username}
              userId={this.props.user?.id}
              testId={`status-update-${this.props.user?.username}-image`}
              hasPlus={this.props.user?.pro}
            />
            <span dangerouslySetInnerHTML={{ __html: statusUpdate.description_icon }} />
          </a>
        </div>
        <div className="comment-content rounded floatright">
          <h4 className="floatleft" dangerouslySetInnerHTML={{ __html: statusUpdate.description_line }} />
          <p className={`clearall info ${StringConstantsMixin.constants.XLATE.NONE}`}>{statusUpdate.time_line}</p>
          <div dangerouslySetInnerHTML={{ __html: statusUpdate.review_text }} />
          <div dangerouslySetInnerHTML={{ __html: statusUpdate.map_link }} />
        </div>
      </div>
    );
  }
});

export { StatusUpdateItem };
